export default [
    {
        path: "transactions",
        name: "bookeeping-transactions",
        redirect: { name: "bookeeping-transactions-list" },
        component: () => import("@/views/commons/transactions/Transactions.vue"),
        meta: {
            section: 35,
            breadcrumb: [
                {
                    text: "Transactions"
                },
            ],
            tabs: [
                {
                    title: "Transactions",
                    name: "bookeeping-transactions-list",
                },
            ],
        },
        children: [
            {
                path: "list",
                name: "bookeeping-transactions-list",
                component: () =>
                    import("@/views/commons/transactions/components/TransactionsTable.vue"),
                meta: {
                    section: 35,
                    tab: "pending",
                    pageTitle: "Transactions",
                    breadcrumb: [
                        {
                            text: "List",
                            active: true,
                        },
                    ],
                },
            },
        ],
    }
]